import { AxiosError } from "axios";
import { OfficeServerDetails } from "../../../domain/repositories/ConfigRepository";

import {
  TRIGGER_CREATE_OFFICE_SERVER,
  TriggerCreateOfficeServer,

  CREATE_OFFICE_SERVER_PENDING,
  CreateOfficeServerPending,

  CREATE_OFFICE_SERVER_SUCCESS,
  CreateOfficeServerSuccess,

  CREATE_OFFICE_SERVER_ERROR,
  CreateOfficeServerError,

  RESET_CREATE_OFFICE_SERVER,
  ResetCreateOfficeServer
} from "./types";

export const triggerCreateOfficeServer = (
  officeServer: string
): TriggerCreateOfficeServer => {
  return {
    type: TRIGGER_CREATE_OFFICE_SERVER,
    payload: { officeServer }
  };
};

export const createOfficeServerPending = (): CreateOfficeServerPending => {
  return {
    type: CREATE_OFFICE_SERVER_PENDING
  };
};

export const createOfficeServerSuccess = (
  createdOfficeServerDetails: OfficeServerDetails
): CreateOfficeServerSuccess => {
  return {
    type: CREATE_OFFICE_SERVER_SUCCESS,
    payload: { createdOfficeServerDetails }

  };
};

export const createOfficeServerError = (error: AxiosError): CreateOfficeServerError => {
  return {
    type: CREATE_OFFICE_SERVER_ERROR,
    payload: { error }
  };
};

export const resetCreateOfficeServer = (): ResetCreateOfficeServer => {
  return {
    type: RESET_CREATE_OFFICE_SERVER,
  };
};